import { PagedResult } from 'src/app/shared/model/generic-paged-result.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileMin } from '../shared/profile-min.model';
import { PagedResultGeneric } from '../../shared';

@Component({
  selector: 'wl-profile-results-grid',
  templateUrl: './profile-results-grid.component.html',
  styleUrls: ['./profile-results-grid.component.css'],
  standalone: false
})
export class ProfileResultsGridComponent implements OnInit {
  @Input('profiles') profileResults: PagedResultGeneric<ProfileMin>;
  @Input() disableSelectForProfileIds: Array<number> = [];
  @Input() selectButtonText: string = 'common.select';

  @Output() onProfileSelected = new EventEmitter<ProfileMin>();

  constructor() {
    this.profileResults = new PagedResult();
  }

  ngOnInit() {}

  public selectProfile(profile: ProfileMin) {
    this.onProfileSelected.emit(profile);
  }
}
